/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Ordinate = {
    value: string;
    direction: Ordinate.direction;
    commentary?: Array<string>;
    confidence?: number;
    is_ai_generated?: boolean;
    is_accepted?: boolean;
};
export namespace Ordinate {
  export enum direction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
  }
}

